<template>
    <div class="answer-item">
        <div class="answer-item__con">
            <div class="answer-item__nickname">
                <v-avatar size="22">A</v-avatar>
                {{ responder.nickname }}
            </div>
            <div class="answer-item__content">
                {{ response.content }}
                <template v-if="response.files.length">
                    <v-chip-group>
                        <v-chip v-for="(file, i) in response.files" :key="i" :value="file._id" :href="file.url" download> {{ file.fileName }} </v-chip>
                    </v-chip-group>
                </template>
            </div>
            <div class="answer-item__reply">
                <span class="answer-item__reply-col answer-item__reply-txt">답글 {{ comments.length }}</span>
                <span class="answer-item__reply-col"><v-btn text @click="showAddComment = !showAddComment" class="answer-item__reply-txt">답글쓰기</v-btn></span>
            </div>
            <div class="answer-item__info">
                <div>
                    <div class="text-center">{{ response?.createdAt?.toDateTime() }}</div>
                    <div v-show="isResponder">
                        <span class="answer-item__info-col">
                            <response-modify v-model="value" :response="response" />
                        </span>
                        <span class="answer-item__info-col">
                            <v-btn text @click="remove">삭제</v-btn>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="answer-items">
            <div class="answer-item">
                <response-comment v-for="comment in comments" :key="comment._id" v-model="value" :comment="comment" />
                <response-comment-add v-show="showAddComment" v-model="value" :response="response" @close="showAddComment = false" />
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import ResponseComment from "./response-comment.vue";
import ResponseModify from "./response-modify.vue";
import ResponseCommentAdd from "./response-comment-add.vue";
export default {
    components: { ResponseComment, ResponseModify, ResponseCommentAdd },
    props: ["value", "response"],
    computed: {
        responder() {
            return this.response.responder || {};
        },
        comments() {
            return this.response.comments || [];
        },
        isResponder() {
            return this.response._responder == this.$store.state.payload._user;
        },
    },
    data() {
        return {
            showModify: false,
            showAddComment: false,
        };
    },
    methods: {
        async remove() {
            try {
                const go = confirm("답변을 삭제하시겠습니까?");
                if (go) {
                    const { counselResponse } = await api.v1.counsels.responses.delete({ _id: this.response._id });
                    alert("삭제되었습니다.");
                    this.$emit("input", {
                        ...this.value,
                        _responses: (this.value._responses || []).filter((_response) => _response !== counselResponse._id),
                        responses: (this.value.responses || []).filter(({ _id }) => _id !== counselResponse._id),
                    });
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
